import { Component, ViewChild, OnInit } from '@angular/core';
import { LocationsService } from '@app/features/locations/shared/locations.service';
import { Location } from '@app/shared/models/location.model';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-location-closures',
    templateUrl: './location-closures.component.html',
    styleUrls: ['./location-closures.component.css'],
    standalone: false
})
export class LocationClosuresComponent implements OnInit {
    @ViewChild('locationTable') locationTable: MatTable<Location>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    isLoading = false;
    locations = []
    displayedColumns = ['storeNumber', 'name', 'address', 'status', 'closedDate'];
    dataSource = new MatTableDataSource<Location>(this.locations);

    constructor(private locationsService: LocationsService) { }

    ngOnInit() {
        this.isLoading = true;
        Promise.resolve(
            this.locationsService.getAllClosedLocations()
        ).then((locations) => {
            locations.forEach(location => {
                this.locations.push(location);
            });
            this.dataSource.paginator = this.paginator;
            this.locationTable.renderRows();
            this.isLoading = false;
        });
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
}